import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-mx-auto tw-px-4 tw-text-sm tw-w-full",
  style: {"max-width":"1200px"}
}
const _hoisted_2 = { class: "tw-float-left tw-mr-4 tw-mb-0 tw-w-1/2" }
const _hoisted_3 = { class: "tw-text-left tw-mb-0" }
const _hoisted_4 = { class: "tw-float-right tw-ml-4 tw-text-gray-500 tw-text-xs" }
const _hoisted_5 = { class: "tw-w-full tw-mt-4" }
const _hoisted_6 = { class: "tw-w-1/3" }
const _hoisted_7 = { class: "tw-mt-2 tw-text-3xl" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "tw-mt-1 tw-text-2xl" }
const _hoisted_11 = { class: "tw-w-full tw-mt-4" }
const _hoisted_12 = {
  key: 0,
  class: "tw-ml-2"
}
const _hoisted_13 = { class: "tw-text-left tw-mb-0 tw-mt-0" }
const _hoisted_14 = { class: "tw-text-left tw-mb-0 tw-mt-0" }
const _hoisted_15 = { class: "tw-text-left tw-mb-0 tw-mt-0" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "tw-ml-2 tw-text-left" }
const _hoisted_18 = { class: "tw-m-0" }
const _hoisted_19 = {
  key: 0,
  class: "tw-m-0"
}
const _hoisted_20 = { class: "tw-m-0" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "tw-mb-0 tw-mt-4" }
const _hoisted_23 = { class: "tw-m-0" }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "tw-ml-2 tw-text-left" }
const _hoisted_27 = { class: "tw-m-0" }
const _hoisted_28 = {
  key: 0,
  class: "tw-m-0"
}
const _hoisted_29 = { class: "tw-m-0" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "tw-mb-0 tw-mt-4" }
const _hoisted_32 = { class: "tw-m-0" }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { class: "tw-w-full tw-mt-4 no-bold" }
const _hoisted_35 = { class: "no-bold" }
const _hoisted_36 = { class: "tw-m-0 tw-text-2xl" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "tw-m-0 tw-text-2xl" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "tw-m-0 tw-text-2xl" }
const _hoisted_41 = { class: "tw-w-full tw-mt-4" }
const _hoisted_42 = { class: "no-bold tw-w-1/6" }
const _hoisted_43 = { class: "no-bold tw-w-1/6" }
const _hoisted_44 = { class: "tw-whitespace-nowrap" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "tw-whitespace-nowrap tw-mt-1" }
const _hoisted_48 = {
  key: 1,
  class: "tw-container tw-mx-auto tw-px-4 tw-text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.order && _ctx.company)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[17] || (_cache[17] = _createElementVNode("a", {
          class: "tw-px-4 tw-py-2 tw-rounded tw-font-medium tw-bg-red-500 tw-text-white hover:tw-bg-red-600 print-button tw-float-right tw-ml-4",
          href: "javascript:window.open('', '_self').close();"
        }, "Close", -1)),
        _cache[18] || (_cache[18] = _createElementVNode("a", {
          class: "tw-px-4 tw-py-2 tw-rounded tw-font-medium tw-bg-blue-500 tw-text-white hover:tw-bg-blue-600 print-button tw-float-right tw-ml-4",
          href: "javascript:window.print();"
        }, "Print", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.company ? _ctx.company.name : '') + " - Order Cover Page ", 1)
        ]),
        _createElementVNode("div", _hoisted_4, "Printed on " + _toDisplayString(_ctx.today()), 1),
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("tbody", null, [
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, "Order #" + _toDisplayString(_ctx.order.id), 1)
            ]),
            (_ctx.order.isExport)
              ? (_openBlock(), _createElementBlock("td", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("h2", { class: "tw-mt-1 tw-text-2xl" }, [
                    _createElementVNode("strong", null, "E"),
                    _createTextVNode(_toDisplayString('xport'))
                  ], -1)
                ]))]))
              : (_openBlock(), _createElementBlock("td", _hoisted_9, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("h2", { class: "tw-mt-1 tw-text-2xl" }, [
                    _createElementVNode("strong", null, "I"),
                    _createTextVNode(_toDisplayString('mport'))
                  ], -1)
                ]))])),
            _createElementVNode("td", null, [
              _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.order.isExport ? 'BKG' : 'BOL') + ": " + _toDisplayString(_ctx.order.billOfLading
                ? _ctx.order.billOfLading.billOfLadingNumber
                : _ctx.order.bookingNumber), 1)
            ])
          ])
        ]),
        _createElementVNode("table", _hoisted_11, [
          _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
            _createElementVNode("th", { class: "no-bold" }, "Pick-Up From"),
            _createElementVNode("th", { class: "no-bold" }, "Delivery To"),
            _createElementVNode("th", { class: "no-bold" }, "Bill to")
          ], -1)),
          _createElementVNode("tbody", null, [
            _createElementVNode("td", null, [
              (_ctx.order.pickUpLocation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.order.pickUpLocation.name), 1)
                    ]),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.addressLine2(_ctx.order.pickUpLocation.address)), 1),
                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.addressLine3(_ctx.order.pickUpLocation.address)), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.order.receiver)
              ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.order.receiver.name), 1)
                    ]),
                    (
                _ctx.order.receiver.deliveryAddress &&
                _ctx.order.receiver.deliveryAddress.streetAddress
              )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.addressLine2(_ctx.order.receiver.deliveryAddress)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.addressLine3(_ctx.order.receiver.deliveryAddress)), 1),
                    (_ctx.order.receivingContact)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.order.receivingContact.phoneNumber
                    ? _ctx.order.receivingContact.phoneNumber
                    : ''), 1),
                          _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.order.receivingContact.name ? _ctx.order.receivingContact.name : ''), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("br", null, null, -1),
                          _createElementVNode("br", null, null, -1),
                          _createElementVNode("br", null, null, -1)
                        ]))]))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.order.billTo)
              ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("p", _hoisted_27, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.order.billTo.name), 1)
                    ]),
                    (
                _ctx.order.billTo.billingAddress &&
                _ctx.order.billTo.billingAddress.streetAddress
              )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.addressLine2(_ctx.order.billTo.billingAddress)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.addressLine3(_ctx.order.billTo.billingAddress)), 1),
                    (_ctx.order.billingContact)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.order.billingContact.phoneNumber
                    ? _ctx.order.billingContact.phoneNumber
                    : ''), 1),
                          _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.order.billingContact.name ? _ctx.order.billingContact.name : ''), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[5] || (_cache[5] = [
                          _createElementVNode("br", null, null, -1),
                          _createElementVNode("br", null, null, -1),
                          _createElementVNode("br", null, null, -1)
                        ]))]))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("table", _hoisted_34, [
          _createElementVNode("thead", null, [
            _cache[7] || (_cache[7] = _createElementVNode("th", { class: "no-bold" }, "Shipline", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("th", { class: "no-bold" }, "Vessel", -1)),
            _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.order.isExport ? 'Vessel Cut-off' : 'ETA'), 1)
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("td", null, [
              _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.order.shipLine), 1)
            ]),
            (_ctx.order.vesselName != 'Vessel Unknown')
              ? (_openBlock(), _createElementBlock("td", _hoisted_37, [
                  _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.order.vesselName), 1)
                ]))
              : (_openBlock(), _createElementBlock("td", _hoisted_39)),
            _createElementVNode("td", null, [
              _createElementVNode("h3", _hoisted_40, _toDisplayString(_ctx.formatVesselEtaDate(_ctx.order.vesselEtaString)), 1)
            ])
          ])
        ]),
        _createElementVNode("table", _hoisted_41, [
          _createElementVNode("thead", null, [
            _cache[9] || (_cache[9] = _createElementVNode("th", { class: "no-bold" }, "#", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("th", { class: "no-bold" }, "Container #", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("th", { class: "tw-w-1/6 no-bold" }, "Size", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("th", { class: "no-bold tw-w-1/6" }, "Appt Date", -1)),
            _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.order.isExport ? 'First Recv Day' : 'First Available Day'), 1),
            _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.order.isExport ? 'Last Recv Day' : 'Last Free Day'), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedContainers, (container, cntrIdx) => {
            return (_openBlock(), _createElementBlock("tbody", {
              key: cntrIdx,
              class: "tw-text-lg"
            }, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_44, _toDisplayString(cntrIdx + 1), 1),
                (container.containerId !== 'EXPUNDEF')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(container.containerId), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_46)),
                _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.containerSizeTypeString(container.sizeType)), 1),
                _cache[13] || (_cache[13] = _createElementVNode("td", null, null, -1)),
                _cache[14] || (_cache[14] = _createElementVNode("td", null, null, -1)),
                _cache[15] || (_cache[15] = _createElementVNode("td", null, null, -1))
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("tr", null, [
                _createElementVNode("td"),
                _createElementVNode("td", { colspan: "5" }, [
                  _createElementVNode("br"),
                  _createElementVNode("br")
                ])
              ], -1))
            ]))
          }), 128))
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_48))
}